import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Carousel, Modal } from "react-bootstrap";

let newResidentialsimgPath = require.context("../../public/images/newResidential", true);
let remodelsimgPath = require.context("../../public/images/remodels", true);
let seismicimgPath = require.context("../../public/images/seismic", true);
let commercialimgPath = require.context("../../public/images/commercial", true);

const heroSlides = [
	remodelsimgPath("./Chelmsford Rd, Hillsborough, CA1.jpg"),
	remodelsimgPath("./25th Avenue, San Francisco, CA4.jpg"),
	remodelsimgPath("./Laidley Street, San Francisco, CA1.jpg"),
	commercialimgPath("./N. Lenore, Willits, CA (2 Buildings)4.jpg"),
	commercialimgPath("./Howard, Burlingame, CA3.jpg"),
	newResidentialsimgPath("./Trinidad Dr, Tiburon, CA7.jpg"),
	remodelsimgPath("./Chelmsford Rd, Hillsborough, CA2.jpg"),
	newResidentialsimgPath("./Pullman Avenue, Half Moon Bay, CA12.jpg"),
	newResidentialsimgPath("./Trinidad Dr, Tiburon, CA2.jpg"),
	newResidentialsimgPath("./Trinidad Dr, Tiburon, CA3.jpg"),
	remodelsimgPath("./Iris Street, San Francisco, CA1.jpg"),
	remodelsimgPath("./Iris Street, San Francisco, CA10.jpg"),
	remodelsimgPath("./Bayswater Ave Burlingame, CA1.jpg"),
	remodelsimgPath("./Rosewood Drive, San Francisco, CA2.jpg"),
	newResidentialsimgPath("./Fir St, South San Francisco, CA1.jpg"),
	newResidentialsimgPath("./Skyfarm Drive, Santa Rosa, CA3.jpg")
];

const featuredProjects = [
	{
		title: "Pullman Avenue Residence",
		meta: "Residential | Half Moon Bay, CA",
		image: newResidentialsimgPath("./Pullman Avenue, Half Moon Bay, CA1.jpg"),
		images: [
			"Pullman Avenue, Half Moon Bay, CA1.jpg", "Pullman Avenue, Half Moon Bay, CA2.jpg", "Pullman Avenue, Half Moon Bay, CA3.jpg", "Pullman Avenue, Half Moon Bay, CA4.jpg", "Pullman Avenue, Half Moon Bay, CA5.jpg", "Pullman Avenue, Half Moon Bay, CA6.jpg", "Pullman Avenue, Half Moon Bay, CA7.jpg", "Pullman Avenue, Half Moon Bay, CA8.jpg", "Pullman Avenue, Half Moon Bay, CA9.jpg", "Pullman Avenue, Half Moon Bay, CA10.jpg", "Pullman Avenue, Half Moon Bay, CA11.jpg", "Pullman Avenue, Half Moon Bay, CA12.jpg", "Pullman Avenue, Half Moon Bay, CA13.jpg", "Pullman Avenue, Half Moon Bay, CA14.jpg"
		].map(file => newResidentialsimgPath("./" + file))
	},
	{
		title: "Laidley Cottage",
		meta: "Remodeling & Addition | San Francisco, CA",
		award: "2018 Remodel of the Year",
		image: remodelsimgPath("./Laidley Street, San Francisco, CA1.jpg"),
		images: Array.from({ length: 10 }, (_, i) => remodelsimgPath(`./Laidley Street, San Francisco, CA${i + 1}.jpg`))
	},
	{
		title: "Steiner Street Building",
		meta: "Seismic Retrofit | San Francisco, CA",
		image: seismicimgPath("./Steiner St, San Francisco, CA1.jpg"),
		images: [seismicimgPath("./Steiner St, San Francisco, CA1.jpg")]
	},
	{
		title: "N. Lenore Building",
		meta: "Commercial & Industrial | Willits, CA",
		image: commercialimgPath("./N. Lenore, Willits, CA (2 Buildings)1.jpg"),
		images: Array.from({ length: 16 }, (_, i) => commercialimgPath(`./N. Lenore, Willits, CA (2 Buildings)${i + 1}.jpg`)).filter(Boolean)
	}
];

const services = [
	{ title: "Residential Structural Engineering", text: "Remodels, additions, and new construction.", icon: "home" },
	{ title: "Steel Design", text: "Structural steel framing and connection support.", icon: "beam" },
	{ title: "Seismic Retrofit Design", text: "Soft-story and existing building retrofit design.", icon: "seismic" },
	{ title: "Foundation Design", text: "Footings, slabs, and foundation systems.", icon: "foundation" },
	{ title: "Retaining Wall Design", text: "Concrete and masonry retaining wall systems.", icon: "wall" },
	{ title: "Commercial Engineering", text: "Structural engineering for commercial and industrial projects.", icon: "building" }
];

const ServiceIcon = ({ type }) => {
	const common = { fill: "none", stroke: "currentColor", strokeWidth: "1.55", strokeLinecap: "round", strokeLinejoin: "round" };
	if (type === "beam") return <svg viewBox="0 0 48 48" aria-hidden="true"><path {...common} d="M14 9h20M14 39h20M18 9v30M30 9v30M18 24h12" /><path {...common} d="M12 15h24M12 33h24" /></svg>;
	if (type === "seismic") return <svg viewBox="0 0 48 48" aria-hidden="true"><path {...common} d="M14 39V14h18v25M19 20h3M19 27h3M19 34h3M26 20h3M26 27h3M26 34h3" /><path {...common} d="M8 36c3-5 6-5 9 0s6 5 9 0 6-5 9 0 6 5 9 0" /></svg>;
	if (type === "foundation") return <svg viewBox="0 0 48 48" aria-hidden="true"><path {...common} d="M10 36h28M14 30h20M18 24h12M21 18h6" /><path {...common} d="M15 36l4-18h10l4 18M12 41h24" /></svg>;
	if (type === "wall") return <svg viewBox="0 0 48 48" aria-hidden="true"><path {...common} d="M9 36h30M9 28h30M9 20h30M9 12h30M15 12v8M27 12v8M21 20v8M33 20v8M15 28v8M27 28v8" /></svg>;
	if (type === "building") return <svg viewBox="0 0 48 48" aria-hidden="true"><path {...common} d="M12 38V12h14v26M26 20h10v18M17 18h4M17 25h4M17 32h4M31 26h2M31 32h2" /></svg>;
	return <svg viewBox="0 0 48 48" aria-hidden="true"><path {...common} d="M9 25L24 12l15 13M14 23v17h20V23M20 40V29h8v11" /></svg>;
};

const Homepage = () => {
	const [selectedProject, setSelectedProject] = useState(null);

	return (
		<main>
			<section className="home-hero home-hero-slideshow">
				<Carousel indicators={false} controls={false} interval={3500} pause={false} fade>
					{heroSlides.map((slide, index) => (
						<Carousel.Item key={index}>
							<img src={slide} alt="NY Engineering residential project" />
						</Carousel.Item>
					))}
				</Carousel>
				<div className="hero-overlay" />
				<div className="home-hero-copy">
					<div className="section-label">Structural Engineering</div>
					<h1>Structural Engineering for Safer, Smarter Buildings</h1>
					<p>NY Engineering provides practical and code-compliant structural engineering solutions for residential, commercial, seismic, and industrial projects across California and New York.</p>
					<div className="button-row">
						<Link className="button button-dark" to="/projects">View Projects</Link>
						<Link className="button button-outline hero-outline" to="/contact">Request Consultation</Link>
					</div>
				</div>
			</section>

			<section className="site-section section-divider">
				<div className="site-container">
					<div className="section-header">
						<div>
							<div className="section-label">Featured Projects</div>
							<h2>Engineering Solutions That Build With Confidence</h2>
						</div>
						<Link className="text-link" to="/projects">View All Projects →</Link>
					</div>
					<div className="project-grid featured-grid">
						{featuredProjects.map(project => (
							<article className="project-card clickable-project-card" key={project.title} onClick={() => setSelectedProject(project)}>
								<div className="project-card-image-wrap">
									<img src={project.image} alt={project.title} />
									<span>View</span>
								</div>
								<h3>{project.title}</h3>
								<p>{project.meta}</p>
								{project.award && <p className="project-award">{project.award}</p>}
							</article>
						))}
					</div>
				</div>
			</section>

			<section className="site-section section-divider">
				<div className="site-container">
					<div className="section-header">
						<div>
							<div className="section-label">Services</div>
							<h2>Comprehensive Structural Engineering Services</h2>
						</div>
						<Link className="text-link" to="/services">View All Services →</Link>
					</div>
					<div className="service-grid">
						{services.map(service => (
							<article className="service-card" key={service.title}>
								<div className="service-icon"><ServiceIcon type={service.icon} /></div>
								<h3>{service.title}</h3>
								<p>{service.text}</p>
							</article>
						))}
					</div>
				</div>
			</section>

			<section className="site-section section-divider">
				<div className="site-container why-layout">
					<div>
						<div className="section-label">Why NY Engineering</div>
						<h2>Experience. Precision. Reliability.</h2>
						<p>We combine technical expertise with practical solutions to deliver safe, efficient, and cost-effective structural designs. Our commitment is to clear communication, code compliance, and successful project outcomes.</p>
					</div>
					<div className="metrics-panel">
						<div><strong>20+</strong><span>Years of Experience</span></div>
						<div><strong>7M+</strong><span>Square Feet Engineered</span></div>
						<div><strong>CA & NY</strong><span>Service Areas</span></div>
						<div><strong>Licensed</strong><span>Engineering Firm</span></div>
					</div>
				</div>
			</section>

			<section className="site-section section-divider process-section">
				<div className="site-container">
					<div className="section-label">Our Process</div>
					<h2>A Clear Process From Start to Finish</h2>
					<div className="process-grid">
						<div><span>01</span><h3>Project Review</h3><p>We review drawings, site conditions, project scope, and structural requirements.</p></div>
						<div><span>02</span><h3>Structural Design</h3><p>We develop practical and economical structural solutions tailored to the project.</p></div>
						<div><span>03</span><h3>Calculations & Drawings</h3><p>We prepare permit-ready drawings and calculations.</p></div>
						<div><span>04</span><h3>Permit Support</h3><p>We assist with plan check comments, revisions, and project coordination.</p></div>
						<div><span>05</span><h3>Construction Administration</h3><p>We provide construction phase support, site observations, and coordination with contractors as needed.</p></div>
					</div>
				</div>
			</section>

			<section className="home-cta">
				<div className="site-container home-cta-inner">
					<div>
						<h2>Have a Project in Mind?</h2>
						<p>Let’s discuss structural solutions for your next project.</p>
					</div>
					<Link className="button button-light" to="/contact">Contact Us →</Link>
				</div>
			</section>

			<Modal show={!!selectedProject} onHide={() => setSelectedProject(null)} dialogClassName="modal-90w" aria-labelledby="featured-project-lightbox">
				<Modal.Header closeButton className="lightbox-header" />
				<Modal.Body className="mx-auto" style={{ width: "100%" }}>
					{selectedProject && (
						<Carousel indicators={false} interval={null}>
							{selectedProject.images.map((src, index) => (
								<Carousel.Item key={index}>
									<img src={src} alt={`${selectedProject.title} ${index + 1}`} />
								</Carousel.Item>
							))}
						</Carousel>
					)}
				</Modal.Body>
			</Modal>
		</main>
	);
};

export default Homepage;
